import { render, staticRenderFns } from "./partLabel.vue?vue&type=template&id=c1f8dd36&scoped=true"
import script from "./partLabel.vue?vue&type=script&lang=js"
export * from "./partLabel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1f8dd36",
  null
  
)

export default component.exports